import React from 'react';
import PropTypes from 'prop-types';
import {graphql} from 'react-apollo';

import gql from 'graphql-tag';
import {createUserAuthTokens} from '../../utils';

const CURRENT_USER_QUERY = gql`
    query refreshToken {
        refreshToken {
            id
            token
            user {
                id
                firstName
                lastName
                role
                email
                createdAt
                street
                city
                postalCode
                mobilePhone
                civility
                birthDate
                hasValidPaymentMethod
                hasActiveSubscription
                isActive
            }
        }
    }
`;

const withUser = Component => {
  const WithUser = ({...props}) => <Component {...props} />;

  WithUser.propTypes = {
    currentUser: PropTypes.object,
    currentUserLoading: PropTypes.bool.isRequired,
  };

  return graphql(CURRENT_USER_QUERY, {
    props({data: {loading, refreshToken, refetch, error}}) {
      if (refreshToken) {
        createUserAuthTokens(refreshToken);
      }
      return {currentUserLoading: loading, currentUser: refreshToken ? refreshToken.user : null, refetchCurrentUser: refetch};
    },
  })(WithUser);
};

const withLoadedUser = Component => {


  const WithLoadedUser = ({currentUserLoading, ...props}) => (currentUserLoading ? null : <Component {...props} />);

  WithLoadedUser.propTypes = {
    currentUser: PropTypes.object,
    currentUserLoading: PropTypes.bool.isRequired,
  };

  return withUser(WithLoadedUser);
};

export {withUser, withLoadedUser};
